import { l as c, m } from "./mobile-BpUO1OTk.mjs";
import { l as d } from "./lodash-5ofSKtz3.mjs";
import { useCallback as h, useState as l, useEffect as u } from "react";
function E(s) {
  const e = window.matchMedia(`only screen and (max-width: ${c}px)`), n = window.matchMedia(`only screen and (max-width: ${m}px)`), a = h(() => ({
    isLargeScreen: e.matches,
    isMediumScreen: n.matches,
    isMobile: e.matches || n.matches
  }), [n, e]), [r, i] = l(a());
  return u(() => {
    const o = a();
    let t;
    return d.isEqual(r, o) || i(o), s && (t = () => {
      i(a());
    }, e.addEventListener("change", t), n.addEventListener("change", t)), () => {
      e.removeEventListener("change", t), n.removeEventListener("change", t);
    };
  }, [r, a, e, n, s]), r;
}
export {
  E as u
};
//# sourceMappingURL=use-screen-sizes-hx44ztp3.mjs.map
